/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PdfDownloadResponse } from './PdfDownloadResponse';
import {
    PdfDownloadResponseFromJSON,
    PdfDownloadResponseFromJSONTyped,
    PdfDownloadResponseToJSON,
    PdfDownloadResponseToJSONTyped,
} from './PdfDownloadResponse';

/**
 * 
 * @export
 * @interface PdfDownloader200Response
 */
export interface PdfDownloader200Response {
    /**
     * 
     */
    data?: PdfDownloadResponse;
}

/**
 * Check if a given object implements the PdfDownloader200Response interface.
 */
export function instanceOfPdfDownloader200Response(value: object): value is PdfDownloader200Response {
    return true;
}

export function PdfDownloader200ResponseFromJSON(json: any): PdfDownloader200Response {
    return PdfDownloader200ResponseFromJSONTyped(json, false);
}

export function PdfDownloader200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfDownloader200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PdfDownloadResponseFromJSON(json['data']),
    };
}

export function PdfDownloader200ResponseToJSON(json: any): PdfDownloader200Response {
    return PdfDownloader200ResponseToJSONTyped(json, false);
}

export function PdfDownloader200ResponseToJSONTyped(value?: PdfDownloader200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PdfDownloadResponseToJSON(value['data']),
    };
}

